import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-rerouting-support-doc',
    templateUrl: './rerouting-support-doc.component.html',
    styleUrls: ['./rerouting-support-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReroutingSupportDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
